module.exports = __webpack_public_path__ + "static/media/shopping-bag.253d4a79.svg";